// @ts-nocheck
const makeEmbedVideoUrl = (url: string) => {
    if (!url.includes("embed") && (url.includes("youtube") || url.includes("youtu.be"))) {
        const regex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^?&]+)/u;
        const replace = "https://www.youtube.com/embed/$1";

        return url.replace(regex, replace);
    }

    return url;
};

export default makeEmbedVideoUrl;
